import script from "./ConnectShopifyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectShopifyModal.vue?vue&type=script&setup=true&lang=js"

import "./ConnectShopifyModal.vue?vue&type=style&index=0&id=5d7446c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7446c6"]])

export default __exports__